import { Theme, FormLabel, FormControlLabel, Grid } from '@material-ui/core';
import React, { useContext, FC, useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { RadioGroup, Radio as MuiRadio } from '@material-ui/core';

import { MobileFieldControlDefinition } from './form/services/layout';
import { parseFieldIdentifier } from './form/services/processor';

import { FormControlProps, useDataFieldValidity, useDataValue, useExpressionValue, useEditability } from './form/utils';
import { FormControl } from './form/components/FormControl';
import { FormContext } from './form/FormContext';
import { TextField } from './form/components/TextField';
import { ChangeEvent } from 'react';

export interface RadioControlDefinition extends MobileFieldControlDefinition<'Radio'> {
  NAOption?: string;
  options: string[];
  optionInputs?: {value: string, dataPath: string}[];
}

export interface RadioProps extends FormControlProps<RadioControlDefinition> {
}

const useStyles = makeStyles(function(theme: Theme) {
  return createStyles( {
    root: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    },
    error: {
      color: theme.palette.error.main,
      marginTop: theme.spacing(-3),
      marginLeft: theme.spacing(3)
    }
  })
});

export const Radio: FC<RadioProps> = function(props) {

  const definition = props.definition;
  const NAOption = definition.NAOption || 'None of the above';
  const optionInputs = definition.optionInputs || [];
  const classes = useStyles(props);
  // const [value, setValue] = useState();
  const { onSetData, onRemoveData, scope } = useContext(FormContext);
  const error = useDataFieldValidity(definition.dataPath);
  const value = useDataValue<string | string[]>(definition.dataPath) || null;
  const options = useExpressionValue<string[]>(definition.options)!;
  const editable = useEditability(definition.editable);

  const [otherDataPath, setOtherDataPath] = useState('');

  useEffect(() => {
    setOtherDataPath('{' + parseFieldIdentifier(definition.dataPath) + 'Other}');
  }, [definition.dataPath])

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (value === 'Other' && event.target.value !== 'Other') {
      onRemoveData(otherDataPath, scope);
    }

    if (optionInputs) {
      let index = optionInputs.findIndex((optionInput) => value === optionInput.value);
      if (index > -1) {
        onRemoveData(optionInputs[index].dataPath, scope);
      }
    }
    onSetData(definition.dataPath, scope, event.target.value);
  }

  return (
    <div className = { classes.root }>
      <FormControl
        label = { definition.label }
        helpText = { definition.helpText }
        footnote = { definition.footnote }
        style = { definition.style }
        tableCell = { definition.tableCell }
        error = { error }>
        <FormLabel></FormLabel>
          <RadioGroup aria-label="gender" name="gender1" value={value} onChange={(e) => handleChange(e)}>
          {
            options.map((option, i) => {
              const index = optionInputs.findIndex((optionInput) => optionInput.value === option)

              return <React.Fragment key={i}>
                {
                  option === 'Other'
                    ? <Grid container direction="row" wrap="nowrap" spacing={1}>
                        <Grid container item xl={1} lg={1} md={2} sm={3} xs={2}>
                          <FormControlLabel
                            control={
                              <MuiRadio value={option} name={option} />
                            }
                            label={option}
                          />
                        </Grid>
                        <Grid container item>
                          { otherDataPath && <TextField path={ otherDataPath } definition={{editable: value === 'Other' && editable, type: 'TextField', label: '', helpText: '', dataPath: otherDataPath, debounceTime: 300 } as any}/> }
                        </Grid>
                      </Grid>
                    : <Grid container direction="row" wrap="nowrap" alignContent="flex-start">
                        <Grid container item style={optionInputs ? { "flex": "0 1 auto", "minWidth": "15%", "maxWidth": "50%", "width": "auto" } : {}}>
                          <FormControlLabel
                            control={
                              <MuiRadio value={option} name={option} />
                            }
                            label={option}
                          />
                        </Grid>
                        {
                          index > -1
                          ?
                            <Grid container item style={{ "flex": "1 1 auto", "minWidth": "50%", "width": "auto" }}>
                              { optionInputs[index] && <TextField path={ optionInputs[index].dataPath } definition={{editable: value === optionInputs[index].value && editable, type: 'TextField', label: '', helpText: '', dataPath: optionInputs[index].dataPath, debounceTime: 300 } as any}/> }
                            </Grid>
                          :
                            <></>
                        }
                      </Grid>
                }
                </React.Fragment>
            })
          }
        </RadioGroup>
      </FormControl>
    </div>
  );
}